import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Loading, UpdateApp } from '@optimization/ssi-common';
import { Outlet } from 'react-router';
import { APP_TITLE, APP_USP } from '@/app/config';
import CollapsedControllerProvider from '@/app/context/CollapsedControllerContext/collapsed-controller-provider';
import DrawerProvider from '@/app/context/DrawerContext/drawer-provider';
import ElementControllerProvider from '@/app/context/ElementControllerContext/element-controller-provider';
import ImportCandidateModalProvider from '@/app/context/ImportCandidateModalContext/import-candidate-modal-provider';
import GlobalLoading from '@/features/GlobalLoading/global-loading';
import {
  Datadog,
  Header,
  ImportCandidates,
  Layout,
  PageNotFound,
  RouteError,
  SolutionHomeOverview,
  ImportedData,
  SolutionManager,
  ChargingHub,
  BevHub,
  BevDetail,
} from '@/route-components';

export const routes = {
  errorElement: (
    <Suspense fallback={<Loading isLoading />}>
      <RouteError />
    </Suspense>
  ),
  element: (
    <ElementControllerProvider>
      <CollapsedControllerProvider>
        <Helmet>
          <title>
            {APP_TITLE} - {APP_USP}
          </title>
        </Helmet>
        <GlobalLoading />
        <Suspense fallback={<Loading isLoading />}>
          <Datadog>
            <UpdateApp appTitle={APP_TITLE}>
              <Header />
              <ImportCandidateModalProvider>
                <DrawerProvider>
                  <Outlet />
                </DrawerProvider>
              </ImportCandidateModalProvider>
            </UpdateApp>
          </Datadog>
        </Suspense>
      </CollapsedControllerProvider>
    </ElementControllerProvider>
  ),
  children: [
    {
      element: (
        <Layout>
          <Outlet />
        </Layout>
      ),
      children: [
        {
          element: <SolutionManager />,
          errorElement: <RouteError />,
          path: '/',
        },
        {
          element: <ImportCandidates />,
          errorElement: <RouteError />,
          path: '/import-candidates',
        },
        {
          element: <Outlet />,
          children: [
            {
              element: <SolutionHomeOverview />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/home',
            },
            {
              element: <ImportedData />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/imported-data',
            },
            {
              element: <ImportedData />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/imported-data/:tabPath',
            },
            {
              element: <BevHub />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bev-hub',
            },
            {
              element: <BevDetail />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bev-hub/:vehicleId',
            },
            {
              element: <BevDetail />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/bev-hub/:vehicleId/:tabPath',
            },
            {
              element: <ChargingHub />,
              errorElement: <RouteError />,
              path: '/solution/:solutionId/charging-hub',
            },
          ],
        },
        {
          path: 'callback',
        },
      ],
    },
    {
      path: '/*',
      element: <PageNotFound className="mt-spacing-88" />,
    },
  ],
};
